import { render, staticRenderFns } from "./top-wrapper.vue?vue&type=template&id=2762f4cc&"
import script from "./top-wrapper.vue?vue&type=script&lang=js&"
export * from "./top-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports